import React from 'react';
import SmartCrypto from '../components/updated/SmartCrypto';
const SmartCryptoPage = () => {
  return <SmartCrypto />;
};

export default SmartCryptoPage;
